import { productApproximateWidth } from '@/features/pos/components/ProductCatalog/parts/ProductList/constants'
import { Mode } from '@/features/pos/components/ProductCatalog/parts/ProductList/types'
import { useEffect, useState } from 'react'
import { LayoutChangeEvent } from 'react-native'

type MeasureLayout = (event: LayoutChangeEvent) => void

export const useMeasureNumColumns = (mode?: Mode): [number | undefined, MeasureLayout] => {
    const [measuredNumColumns, setMeasuredNumColumns] = useState<number>()

    useEffect(() => {
        if (mode === 'column') {
            setMeasuredNumColumns(undefined)
        }
    }, [mode])

    const measureLayout: MeasureLayout = (event: LayoutChangeEvent) => {
        if (mode === 'column') return

        const layoutWidth = event.nativeEvent.layout.width

        if (layoutWidth <= 0) return

        setMeasuredNumColumns(Math.max(1, Math.round(layoutWidth / productApproximateWidth)))
    }

    return [measuredNumColumns, measureLayout]
}
